const CudaLaunchApp = require("CudaLaunchApp.js");
const AppsPlugin = require("apps/AppsPlugin");
const NavHistoryManager = require("./navigation/BrowserNavigationHistory");
const postal = require("common/PubSub");
const SettingsPlugin = require("settings/SettingsPlugin");
const DownloadsSettingsDelegate = require("downloads/DownloadsSettingsDelegate");
const DownloadsListView = require("downloads/DownloadsListView");
const VPNConfigDownloadView = require("downloads/VPNConfigDownloadView");
const NetworkPlacesPlugin = require("network_places/NetworkPlacesPlugin");
const DynAppsPlugin = require("dyn_apps/DynAppsPlugin");
const TunnelsRenderer = require("tunnels/TunnelsRenderer");
const Utils = require("common/Utils");

// Add browser detection capabilities to client config
CudaLaunch.clientConfiguration.addExtension(require("./client_config/BrowserPluginDetector"));
CudaLaunch.clientConfiguration.addExtension(require("./client_config/BrowserLocaleDetector"));
CudaLaunch.clientConfiguration.addExtension(require("./client_config/BrowserOSDetector"));
CudaLaunch.clientConfiguration.addExtension(require("./client_config/BrowserUserInteractionDetector"));

let browserNavHistory;

postal.channel("RootController").subscribe("rootControllerLoaded", function() {
    CudaLaunch.controllers.RootController.addPreAuthMenu();
});

postal.channel("Configuration").subscribe("language", function() {
    window.location.reload();
});

$(document).on("loadappmodules", function() {
    // The Web Portal doesn't support Tunnels - however you could have a DynApp tunnel which should be rendered correctly.
    const tunnelsRenderer = new TunnelsRenderer();
    new DynAppsPlugin({explicit_port_forward : tunnelsRenderer}).start();

    new AppsPlugin().start();

    const clientConfig = CudaLaunch.clientConfiguration;
    const vpnDownloadsView = new VPNConfigDownloadView();
    const settingsDelegates = [new DownloadsSettingsDelegate(clientConfig, new DownloadsListView(clientConfig, vpnDownloadsView), vpnDownloadsView)];
    new SettingsPlugin().start(settingsDelegates);

    new NetworkPlacesPlugin().start();
});

postal.channel("Electron").subscribe("open-external", function(url) {
    window.open(url, "_blank");
});

$(document).on("mobileinit", function() {
    browserNavHistory = new NavHistoryManager();
});

$(document).on("appinit", function() {
    i18n.loadNamespace("web");
    document.title = Utils.getServerProductName();
});

CudaLaunchApp();